/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductSearchResponse } from '../../models/page-product-search-response';
import { ProductSearchDetailsFilter } from '../../models/product-search-details-filter';

export interface SearchProduct$Params {

/**
 * Determines which logic will be used BUYING/SELLING
 */
  marketplaceSection: 'BUYING' | 'SELLING';

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
      body: ProductSearchDetailsFilter
}

export function searchProduct(http: HttpClient, rootUrl: string, params: SearchProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductSearchResponse>> {
  const rb = new RequestBuilder(rootUrl, searchProduct.PATH, 'post');
  if (params) {
    rb.query('marketplaceSection', params.marketplaceSection, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductSearchResponse>;
    })
  );
}

searchProduct.PATH = '/search/products';
